import React from 'react';

const RequiredFieldMarker: React.FC = () => <sup style={{ color: 'red' }}>*</sup>;

export default RequiredFieldMarker;
